<template>
  <el-card v-loading="loading">
    <div ref="scrollContainer" id="page-panel" >
      <!-- <resize-observer @notify="__resizeHanlder" /> -->

        <div class="customer-top-nav">
          <div class="title">
            <span>{{$t('reports.names.'+reportCode)}}</span><br>
          </div>
          <div class="controls no-print">
            <el-button @click="print" size="small"><i class="mdi mdi-printer"></i> Imprimer</el-button>
    				 <el-button type="primary" @click="openFilterDialog" size="small"><i class="mdi mdi-filter"></i> </el-button>
    			</div>
        </div>

        <p>
          <span class="fs-14 secondary-text">{{companyName}}</span><br>
          <span class="fs-14 secondary-text">{{currentFilterPeriod}}</span>
        </p>
        <div id="printMe">
        <el-table :data="usableData" :style="tableWidth" :span-method="arraySpanMethod" v-if="data.fiscalInfo!=null" :cell-style="cellStyleFct">
          <el-table-column fixed width="200">
            <template slot-scope="scope">
              <span class="fs-14" v-if="scope.row.header"><strong>{{$t('reports.PROFIT_LOSS.headers.'+scope.row.name)}}</strong></span>
              <span class="fs-12 pl-15" v-else>
                {{scope.row.name}}<span v-if="scope.row.number!=null">({{scope.row.number}})</span>
              </span>
            </template>
          </el-table-column>

          <el-table-column v-for="index in nbColumns" :key="index" :label="showPeriodName(index-1+data.fiscalInfo.fiscalEndMonth)">
            <template slot-scope="scope">
               <span class="fs-12" v-if="scope.row[getRealPeriodNumber(index)]!=null">{{scope.row[getRealPeriodNumber(index)]}} $</span>
               <span class="fs-12" v-else>- -</span>
            </template>
          </el-table-column>

          <el-table-column fixed="right" width="150" label="Total annuel">
            <template slot-scope="scope">
              <span class="fs-12">{{scope.row.total}} $</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <reportFilter :visible="reportFilterVisible" @close="closeFilterDialog" :predefinedPeriod="predefinedPeriod" :groups="groups" :group="filters.groupBy" :period="period" :startDate="this.filters.startDate" :endDate="this.filters.endDate" @applyFilter="handleFilter" :paymentMethods="[]" :methods="[]"></reportFilter>
    </div>
  </el-card>
</template>
<script>
//import Section
import salesAPI from '@/services/API/sales.js'
import systemAPI from '@/services/API/system.js'
import moment from 'moment'
import reportFilter from './report-filter'
import reportUtil from '@/utils/report-util.js'
export default {
  name : "report-profit-loss",
  props : {
    width : {
      type : Number,
      default : 100
    },
    fiscalEndDay : Number,
    fiscalEndMonth : Number,
    lastFiscalYearDate : Object,
    fiscalYearDate : Object,
    companyName : '',
  },
  data() {
    return {
      output : null,
      data : [],
      loading:true,
      totalProfitByPeriod : [0,0,0,0,0,0,0,0,0,0,0,0,0],
      totalProfit : 0.00,
      totalSalesByPeriod : [0,0,0,0,0,0,0,0,0,0,0,0,0],
      totalSales : 0.00,
      totalExpensesByPeriod : [0,0,0,0,0,0,0,0,0,0,0,0,0],
      totalExpenses : 0.00,
      filters : {
        range : null,
        startDate : null,
        endDate : null,
        groupBy : null,
        based : null,
      },
      reportFilterVisible : false,
      pageWidth : null,
      pageHeight : null,

    };
  },
  components : {
    reportFilter
  },
  computed : {
    tableWidth(){
      return 'width : ' + this.width + 'px;';
    },
    nbColumns(){
      return this.filters.groupBy==='MONTH'?12:4;
    },
    currentFilterPeriod(){
      return reportUtil.currentFilterPeriod(this.fiscalYearDate,this.lastFiscalYearDate,this.filters.range,this.filters.startDate,this.filters.endDate )

    },
    predefinedPeriod(){
      if(this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        return [
          {code : 'FISCAL_YEAR',description:this.fiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.fiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'LAST_FISCAL_YEAR',description:this.lastFiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.lastFiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'CUSTOM', range:true}
        ]
      }else{
        return [];
      }

    },
    period(){
      return _.find(this.predefinedPeriod, p=>{return p.code==this.filters.range})
    },
    groups(){
      return ['MONTH','QUARTER']
    },
    reportCode(){
      return this.$route.params.code;
    },
    usableData(){
      let data = [
        {name:'sales',header:true,section:true, span:true},
        ...this.processDataByPeriod(this.data.sales,'SALES'),
        ...this.processDataByPeriod(this.data.creditNotes,'SALES'),
        {name:'total_sales',header:true,total:Math.round(this.totalSales*100)/100, ...this.totalSalesByPeriod},
        {name:'expenses',header:true,section:true, span:true},
        {name:'total_expenses',header:true,total:Math.round(this.totalExpenses*100)/100, ...this.totalExpensesByPeriod},
        {name:'total_profit',header:true,section : true,total:Math.round(this.totalProfit*100)/100, ...this.totalProfitByPeriod},
      ];
      return data;
    }
  },
  methods : {
    print(){
       const element = window.document.getElementById('page-panel');

       _.forEach(element.getElementsByTagName('table'), t=>{
         t.style.width='100%';
         t.style['table-layout']='auto';
       })
       const url = '';
       const win = window.open('', '', 'left=0,top=0,width=1000,height=600,toolbar=yes,scrollbars=yes,status=yes', true);

        // Get all stylesheets HTML
        let stylesHtml = '';
        for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
          stylesHtml += node.outerHTML;
        }
        win.document.write(`
        <html style="overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset">
          <head>
            <title>${window.document.title}</title>
            <styles>${stylesHtml}</styles>
          </head>
          <body style="overflow-x: hidden;overflow-y: auto;height:auto;width:100%;display:block;position:unset;">
            ${element.innerHTML}
          </body>
        </html>
      `);
      setTimeout(() => {
        win.document.close();
        win.focus();
        // win.print();
        // win.close();
      }, 1000);


    },
    _moment(date){
      return moment(date);
    },
    handleFilter(filters){
      localStorage.profit_loss_groupBy=filters.group;
      localStorage.profit_loss_range=filters.period.code;
      localStorage.profit_loss_startDate = filters.dateRange[0];
      localStorage.profit_loss_endDate = filters.dateRange[1];
      this.setFilters();
      this.fetchData();
    },
    openFilterDialog(){
      this.reportFilterVisible = true;
    },
    closeFilterDialog(){
      this.reportFilterVisible=false;
    },
    cellStyleFct({row, column, rowIndex, columnIndex}){
      if(row.section){
        return {'padding-top':'30px','border-top':'1px solid #4a596a'}
      }
    },
    processDataByPeriod(data, type){
      let tmpData = [];
      _.forEach(data, s=>{
        let totalGl = 0.00;
        if(s.name!=null){
          let gl = {name:s.name, number:s.number, total:0.00};
          _.forEach(s.periods, p=>{
            gl[p.month] = p.profit;
            gl.total=Math.round((gl.total+p.profit)*100)/100;
            if(type=='SALES'){
              this.totalSalesByPeriod[p.month]=Math.round((this.totalSalesByPeriod[p.month]+p.profit)*100)/100;
              this.totalSales+=p.profit;
            }else{
              this.totalExpensesByPeriod[p.month]=Math.round((this.totalExpensesByPeriod[p.month]+p.profit)*100)/100;
              this.totalExpenses+=p.profit;
            }
            this.totalProfitByPeriod[p.month]=Math.round((this.totalProfitByPeriod[p.month]+p.profit)*100)/100;
            this.totalProfit+=p.profit;

          })
          tmpData.push(gl);
        }

      })
      return tmpData;
    },
    getRealPeriodNumber(falseNumber){
      let number = falseNumber;
      if(falseNumber>12){
        number-=12;
      }
      return number;
    },
    showPeriodName(periodNumber){
      if(this.filters.groupBy=='MONTH'){
        return moment().month(this.getRealPeriodNumber(periodNumber)).format('MMM');
      }else{
        let realPeriodNumber= this.getRealPeriodNumber(periodNumber);
        let startMonth = moment().month(((realPeriodNumber+1)*3)-3).format('MMM');
        let endMonth = moment().month(((realPeriodNumber+1)*3)-1).format('MMM');
        return startMonth + '-' + endMonth
      }

    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if(row.span){
          return {rowspan:1, colspan:this.nbColums+2}
        }else{
          return {rowspan:1, colspan:1}
        }
      },

		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
  			this.setPageWidth();
  		}, 700),
    fetchData(){
      this.loading = true;
      this.totalProfitByPeriod = [0,0,0,0,0,0,0,0,0,0,0,0,0];
      this.totalSalesByPeriod = [0,0,0,0,0,0,0,0,0,0,0,0,0];
      this.totalExpensesByPeriod = [0,0,0,0,0,0,0,0,0,0,0,0,0];
      this.totalProfit = 0.00;
      this.totalSales = 0.00;
      this.totalExpenses = 0.00;
      let filters = _.cloneDeep(this.filters);
      if(filters.startDate!=null){
        filters.startDate = moment(filters.startDate).format('YYYY-MM-DD Z');
      }
      if(filters.endDate!=null){
        filters.endDate = moment(filters.endDate).format('YYYY-MM-DD Z');
      }

      return salesAPI.getReportInfo(this.reportCode, filters)
        .then(data=>{
          this.data = data;
          this.loading = false;
        }).catch(err=>{
          console.log(err);
          this.loading = false;
          this.$message.error('Une erreur système est survenue. Veuillez réessayer plus tard')
        })
    },
    setFilters(){
      if(localStorage.profit_loss_range==null){
        localStorage.profit_loss_range='FISCAL_YEAR';
      }
      if(localStorage.profit_loss_groupBy==null){
        localStorage.profit_loss_groupBy='MONTH';
      }
      if(localStorage.profit_loss_based==null){
        localStorage.profit_loss_based='BILLED';
      }

      this.filters.based = localStorage.profit_loss_based;
      this.filters.groupBy = localStorage.profit_loss_groupBy;

      this.filters.range=localStorage.profit_loss_range

      if(this.filters.range=='FISCAL_YEAR' && this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        localStorage.profit_loss_startDate = this.fiscalYearDate.startDate;
        localStorage.profit_loss_endDate = this.fiscalYearDate.endDate;
      }else if(this.filters.range=='LAST_FISCAL_YEAR' && this.lastFiscalYearDate.startDate!=null && this.lastFiscalYearDate.endDate!=null){
        localStorage.profit_loss_startDate = this.lastFiscalYearDate.startDate;
        localStorage.profit_loss_endDate = this.lastFiscalYearDate.endDate;
      }

      this.filters.startDate = localStorage.profit_loss_startDate;
      this.filters.endDate = localStorage.profit_loss_endDate;
    }
  },
  mounted(){
    this.setPageWidth();
  },
  created(){
    this.loading = true;
    this.setFilters();
    this.fetchData();
  },
  beforeDestroy(){
    this.data = [];
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

@media print {
  @page {
    size: landscape !important;
  }
  body, html { margin-top:0%;
    font-size:0.2em;
     display:block;
     height:100%;
     width:100%;
     position:unset !important;
     background:none;
     overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset
   }
   .no-print{
   	display:none;
   }
   .el-card{
     border:none;
     width:100%;
     font-size:0.2em;
   }
   p, div, span {
     font-size:12px;
   }




}



.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


</style>
